import React, { useContext, useState, useEffect } from "react";
import { BudgetReport } from "./BudgetComponents/BudgetReport";
import { useHistory } from "react-router-dom";
import DEATH_API from "../../apis/death.api";
import { useDispatch, useSelector } from "react-redux";
import { Menu, Dropdown } from "antd";
import editIcon from "../../assets/images/budget/dropdown.png";
import {
  setRefreshTime,
  setRefreshTimeAsset,
} from "../../redux/slices/itemsSlice";
import { MODULE_API } from "../../apis";
import { ProgressContext } from "../../utils/ProgressContext";
import swal from "sweetalert";
import moment from "moment";
import ModalVideo from "../ModuleVideos/ModalVideo";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";
import {
  PlaidButtonSpinner,
  PlaidLoadingMessage,
} from "../Plaid/PlaidLoadingStates";
import "../Plaid/Plaidmain.css";
import "./BudgetMain.css";

export const BudgetMain = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [pageLoadingState, setPageLoadingState] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [budgetData, setBudgetData] = useState(null);
  const [syncPayload, setSyncPayload] = useState([]);
  const [clientBanks, setClientBanks] = useState(null);
  const { startLoading, stopLoading, loadingProgress } =
    useContext(ProgressContext);
  const refreshTime = useSelector(
    (state) => state.rootReducer.itemsInfo.refreshTimeAsset
  );
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const financialAccess =
    localStorage.getItem("financialAccess") != "undefined" &&
    JSON.parse(localStorage.getItem("financialAccess") || null);
  const getUserTransactions = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBankAccountDetails();
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getBudgetData = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBudgetDataAll();
      if (data && data.status === 200 && data.data) {
        // setBudgetData(data.categorized);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getCalculatedBudget = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getCalculatedBudget();
      if (data && data.status === 200 && data.categoryBudgets) {
        console.log("data", data.categoryBudgets);
        const usedAmounts = data.categoryBudgets.map(
          (item) => item.value.usedAmount
        );
        const categoryName = data.categoryBudgets.map(
          (item) => item.value.categoryName
        );
        const amountsSums = data.categoryBudgets.reduce((accumulator, item) => {
          accumulator.push(item.value.usedAmount + item.value.leftAmount);
          return accumulator;
        }, []);
        console.log("categorires", usedAmounts, categoryName, amountsSums);
        const resultObject = {
          usedAmounts,
          categoryName,
          amountsSums,
        };
        setBudgetData(resultObject);
        // setCategoryBudget(data.categoryBudgets);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getTransactions = async (showLoader = true) => {
    try {
      if (showLoader) setLoading(true);
      let data = await DEATH_API.getBudgetTransaction();
      if (data && data.data) {
        const allAccount = data.data.map((item) => {
          // If amount is negative, convert it to positive
          if (item.amount && item.typeOfTransaction === null) {
            item.amount = -1 * item.amount;
          }
          return item;
        });
        const checkingSavingData = allAccount.filter((item) => {
          return (
            (item.accountType === "checking" ||
              item.accountType === "savings") &&
            item.categoryFromPlaid !== null
          );
        });
        const creditData = allAccount.filter((item) => {
          return (
            item.accountType === "credit card" &&
            item.categoryFromPlaid !== null
          );
        });
        const investmentData = allAccount.filter((item) => {
          return (
            item.accountType !== "checking" &&
            item.accountType !== "savings" &&
            item.accountType !== "credit card" &&
            item.accountType !== "student" &&
            item.accountType !== "loan" &&
            item.accountType !== "auto" &&
            item.accountType !== "business" &&
            item.accountType !== "commercial" &&
            item.accountType !== "construction" &&
            item.accountType !== "consumer" &&
            item.accountType !== "overdraft" &&
            item.accountType !== "home equity" &&
            item.accountType !== "line of credit" &&
            item.accountType !== "mortgage" &&
            item.categoryFromPlaid !== null
          );
        });
        const studentData = allAccount.filter((item) => {
          return (
            (item.accountType === "student" ||
              item.accountType === "mortgage" ||
              item.accountType === "loan" ||
              item.accountType === "auto" ||
              item.accountType === "business" ||
              item.accountType === "commercial" ||
              item.accountType === "construction" ||
              item.accountType === "consumer" ||
              item.accountType === "overdraft" ||
              item.accountType === "home equity" ||
              item.accountType === "line of credit") &&
            item.categoryFromPlaid !== null
          );
        });
        const cashData = allAccount.filter((item) => {
          return item.paidUsing === "Cash" && item.categoryFromPlaid !== null;
        });
        const nullCategoryDataNullCategory = allAccount.filter((item) => {
          return item.categoryFromPlaid === null;
        });

        const resultObject = {
          allAccount,
          checkingSavingData,
          creditData,
          investmentData,
          studentData,
          nullCategoryDataNullCategory,
          cashData,
        };
        setTransactions(resultObject);
      }
      if (showLoader) setLoading(false);
    } catch (error) {
      console.log(error);
      if (showLoader) setLoading(false);
    }
  };
  useEffect(() => {
    getAllResults();
  }, []);

  const getAllResults = async (loadingState = "loadDashboard") => {
    try {
      if (loadingState) setPageLoadingState(loadingState);
      setLoading(true);
      // await getCalculatedBudget();
      // await getUserTransactions();
      await getBankDetails(false);
      await getTransactions(false);
    } finally {
      setLoading(false);
      if (loadingState) setPageLoadingState(null);
    }
  };
  const refreshAssetModule = async (showLoader = true) => {
    try {
      if (showLoader) setLoading(true);
      const response = await MODULE_API.refreshAssetModule();
      if (
        response &&
        response.status === 200 &&
        response.updatedAt &&
        response.updatedAt
      ) {
        dispatch(setRefreshTimeAsset(response.updatedAt));
      }
      // console.log("response",response)
      // if(response && response.status===429){
      //   swal("Oops!",response.message,"error");
      // }
      if (showLoader) setLoading(false);
    } catch (error) {
      if (showLoader) setLoading(false);
      console.error("Error fetching user data:", error);
    }
  };
  const refreshLiabilityModule = async (showLoader = true) => {
    try {
      if (showLoader) setLoading(true);
      const response = await DEATH_API.refreshLiability();
      console.log("response refresf", response.data);
      if (
        response &&
        response.status === 200 &&
        response.updatedAt &&
        response.updatedAt.updatedAt
      ) {
        dispatch(setRefreshTime(response.updatedAt.updatedAt));
      }
      if (showLoader) setLoading(false);
    } catch (error) {
      if (showLoader) setLoading(false);
      console.error("Error fetching user data:", error);
    }
  };
  const refreshDataPlaid = async () => {
    try {
      // setLoading(true);
      const interval = startLoading();

      const refreshData = await DEATH_API.refreshBanksData(
        syncPayload && { accounts: syncPayload }
      );
      if (refreshData && refreshData.status === 200) {
        await refreshLiabilityModule(false);
        await refreshAssetModule(false);
      }
      if (refreshData && refreshData.status === "ERROR") {
        swal("Oops!", refreshData.message, "error");
      }
      clearInterval(interval);
      stopLoading();
      // setLoading(false);
    } catch (error) {
      console.log(error);
      // setLoading(false);
      stopLoading(0);
    }
  };
  const getBankDetails = async (showLoader = true) => {
    try {
      if (showLoader) setLoading(true);
      let data = await DEATH_API.getBankDetails();
      setSyncPayload([]);
      let obj = [];
      let bankData = {};
      if (data && data.data) {
        const newArray = data.data.map((account) => {
          return {
            accountId: account.accountId,
            accountName: `${account.accountName}`,
            bankName: account.bankName,
            subType: account.subType,
            accountNumber: account.mask,
            accountTitle: `${account.accountName} ${account.mask}`,
            balance: account.balance,
          };
        });
        setClientBanks([
          ...newArray,
          {
            accountId: 1234,
            accountName: "cash",
            bankName: "devbank",
            subType: "debsubtype",
            accountNumber: 1122,
            accountTitle: "Cash",
            balance: 1111,
          },
        ]);

        data.data.forEach((item) => {
          if (!bankData[item.bankName]) {
            bankData[item.bankName] = [];
          }
          bankData[item.bankName].push({
            ...item,
            bankName: item.bankName,
            mask: item.mask,
          });
        });
        data.data.map((item, idx) => {
          obj.push({
            bankName: item.bankName,
            mask: item.mask,
            accessToken: item.accessToken,
          });
        });
      }
      setSyncPayload((prevState) => [...prevState, ...obj]);
      if (showLoader) setLoading(false);
    } catch (error) {
      console.log(error);
      if (showLoader) setLoading(false);
    }
  };
  const syncAllPlaid = async () => {
    try {
      setPageLoadingState("refreshDashboard");
      // await refreshDataPlaid();
      await getAllResults(null);
    } finally {
      setPageLoadingState(null);
    }
  };
  const isBusy = loading || loadingProgress;

  return (
    <div className="BudgetMain">
      <ModalVideo module="Budget" autoOpen={true} />
      <div className="budgetcreate" style={{ justifyContent: "space-between" }}>
        <div className="addbudgetSection">
          <div className="addTitle">
            Dashboard
            <span style={{ marginLeft: "10px" }}>
              <Dropdown
                trigger={["click"]}
                overlay={
                  <Menu>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget");
                        }}
                      >
                        Dashboard
                      </div>
                    </Menu.Item>
                    {(!financialAccess || !financialAccess.hideTransactions) && (
                      <Menu.Item>
                        <div
                          onClick={() => {
                            history.push("/budget/add/transaction");
                          }}
                        >
                          Transactions
                        </div>
                      </Menu.Item>
                    )}
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget/add/budget");
                        }}
                      >
                        Budget
                      </div>
                    </Menu.Item>
                    {(!financialAccess || !financialAccess.hideTransactions) && (
                      <Menu.Item
                      // style={{ cursor: "not-allowed", opacity: "0.7" }}
                      >
                        <div
                          onClick={() => {
                            history.push("/budget/transaction/recurring");
                          }}
                        >
                          Recurring
                        </div>
                      </Menu.Item>
                    )}
                  </Menu>
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                >
                  <img src={editIcon} height={12} width={18} alt="icon"></img>
                </a>
              </Dropdown>
            </span>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              color: "black",
            }}
          >
            {refreshTime &&
              `Updated at: ${moment(refreshTime)
                .local()
                .format("MM/DD/YYYY [at] hh:mmA")}`}
          </div>
          {(userRole && userRole !== "FreeTrail") ||
          userRole !== "Financial Advisor Client" ? (
            <div style={{
                display: "flex",
                gap: "0.5rem",
              }}>
            <button
              className={
                syncPayload && syncPayload.length === 0
                  ? "addbuttonassets disableButton"
                  : "addbuttonassets"
              }
              disabled={(syncPayload && syncPayload.length === 0) || isBusy}
              onClick={() => {
                syncAllPlaid();
              }}
              style={{
                opacity:
                  (syncPayload && syncPayload.length === 0) || isBusy ? 0.7 : 1,
                cursor:
                  (syncPayload && syncPayload.length === 0) || isBusy
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              {loadingProgress || pageLoadingState === "refreshDashboard" ? (
                <span className="budget-button-content">
                  <PlaidButtonSpinner />
                  Refreshing...
                </span>
              ) : (
                "Recalculate Budget"
              )}
            </button>
            <ToolTipCreator name="Refresh Budget" />
            </div>
          ) : null}
          {(userRole && userRole !== "FreeTrail") ||
          userRole !== "Financial Advisor Client" ? (
            <button
              className="addbuttonassets"
              disabled={isBusy}
              style={{
                opacity: isBusy ? 0.7 : 1,
                cursor: isBusy ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                history.push("/plaid");
              }}
            >
              + Link Account
            </button>
          ) : null}
          {localStorage.getItem("role") &&
            JSON.parse(localStorage.getItem("role")) !==
              "Financial Advisor Client" && (
              <button
                className="addbuttonassets"
                disabled={isBusy}
                style={{
                  opacity: isBusy ? 0.7 : 1,
                  cursor: isBusy ? "not-allowed" : "pointer",
                }}
                onClick={() => {
                  history.push("/budget/add/budget");
                }}
              >
                + Add Budget
              </button>
            )}
        </div>
      </div>
      <div className="BudgetMainReport">
        {(loadingProgress || pageLoadingState === "refreshDashboard") && (
          <PlaidLoadingMessage
            compact={true}
            title="Refreshing Budget Dashboard"
            description="Syncing transactions and updating category balances."
            progress={loadingProgress}
          />
        )}
        <BudgetReport
          transactions={transactions && transactions}
          clientBanks={clientBanks && clientBanks}
          isLoading={isBusy}
        />
      </div>
    </div>
  );
};
